import React from 'react'
import { QueryObserverResult } from 'react-query'

import { IUser } from '@monorepo/interfaces'

export const UserContext = React.createContext<QueryObserverResult<IUser>>(
  undefined as any
)
